import { ArrowRight, ArrowDown } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logo from '../../../assets/world_ciber.png';

export default function Hero() {
  const { t } = useTranslation();

  const styles = `
    @keyframes slideInLeft {
      from {
        opacity: 0;
        transform: translateX(-50px);
      }
      to {
        opacity: 1;
        transform: translateX(0);
      }
    }

    @keyframes slideInRight {
      from {
        opacity: 0;
        transform: translateX(50px);
      }
      to {
        opacity: 1;
        transform: translateX(0);
      }
    }

    .slide-in-left {
      opacity: 0;
      transform: translateX(-50px);
      animation: slideInLeft 1.5s ease-out forwards;
    }

    .slide-in-right {
      opacity: 0;
      transform: translateX(50px);
      animation: slideInRight 1.5s ease-out forwards;
      animation-delay: 0.3s;
    }

    /* Capa de estrellas */
    .stars {
      position: absolute;
      inset: 0;
      background: #000; /* color base negro */
      z-index: 0;
      background-image:
        radial-gradient(2px 2px at 10% 20%, #fff, transparent),
        radial-gradient(1.5px 1.5px at 20% 80%, #fff, transparent),
        radial-gradient(1px 1px at 30% 30%, #fff, transparent),
        radial-gradient(2px 2px at 40% 90%, #fff, transparent),
        radial-gradient(1.5px 1.5px at 50% 50%, #fff, transparent),
        radial-gradient(1px 1px at 60% 70%, #fff, transparent),
        radial-gradient(2px 2px at 70% 40%, #fff, transparent),
        radial-gradient(1.5px 1.5px at 80% 60%, #fff, transparent),
        radial-gradient(1px 1px at 90% 10%, #fff, transparent),
        radial-gradient(2px 2px at 15% 50%, #fff, transparent),
        radial-gradient(1.5px 1.5px at 85% 20%, #fff, transparent),
        radial-gradient(1px 1px at 25% 60%, #fff, transparent),
        radial-gradient(2px 2px at 5% 10%, #fff, transparent),
        radial-gradient(1.5px 1.5px at 95% 80%, #fff, transparent),
        radial-gradient(1px 1px at 50% 90%, #fff, transparent),
        radial-gradient(2px 2px at 75% 25%, #fff, transparent),
        radial-gradient(1.5px 1.5px at 35% 65%, #fff, transparent),
        radial-gradient(1px 1px at 65% 35%, #fff, transparent),
        radial-gradient(2px 2px at 85% 15%, #fff, transparent),
        radial-gradient(1.5px 1.5px at 95% 95%, #fff, transparent),
        radial-gradient(1px 1px at 5% 95%, #fff, transparent),
        radial-gradient(2px 2px at 15% 15%, #fff, transparent),
        radial-gradient(1.5px 1.5px at 25% 25%, #fff, transparent),
        radial-gradient(1px 1px at 35% 35%, #fff, transparent),
        radial-gradient(2px 2px at 45% 45%, #fff, transparent),
        radial-gradient(1.5px 1.5px at 55% 55%, #fff, transparent),
        radial-gradient(1px 1px at 65% 65%, #fff, transparent),
        radial-gradient(2px 2px at 75% 75%, #fff, transparent),
        radial-gradient(1.5px 1.5px at 85% 85%, #fff, transparent),
        radial-gradient(1px 1px at 95% 5%, #fff, transparent);
      background-size: cover;
      background-repeat: repeat;
    }
  `;

  return (
    <div className="relative h-screen md:h-[calc(100vh-136px)] overflow-hidden">
      <style>{styles}</style>

      <div className="stars" />
      <div className="absolute inset-0 bg-black/30 z-10" />

      <div className="relative z-20 flex flex-col md:flex-row items-center justify-center h-full w-full md:-translate-y-6">

        <div className="md:w-1/2 px-6 py-12 md:py-0 text-center md:text-left slide-in-left">
          <div className="inline-block mb-4 px-4 py-1.5 bg-primary/30 rounded-full text-primary/200 text-sm font-medium animate-pulse">
            {t('home.hero_discover')}
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            {t('home.hero_title')}<br className="hidden md:block" /> {t('home.hero_subtitle')}
          </h1>

          <p className="text-lg md:text-xl text-textLight mb-8 max-w-lg mx-auto md:mx-0">
            {t('home.hero_description')}
          </p>

          <div className="flex flex-col sm:flex-row justify-center md:justify-start gap-4 mb-12">
            <button
              onClick={() => document.getElementById('contact-section')?.scrollIntoView({ behavior: 'smooth' })}
              className="group bg-primary text-white px-6 md:px-8 py-3 rounded-lg font-semibold transition transform hover:bg-accent active:scale-95 hover:shadow-lg flex items-center"
            >
              {t('home.hero_try_free')}
              <ArrowDown className="ml-2 h-5 w-5 group-hover:translate-y-1 transition-transform" />
            </button>

            <Link
              to="/documentation"
              className="group border border-primary text-primary px-6 md:px-8 py-3 rounded-lg font-semibold hover:bg-primary hover:text-white transition transform hover:scale-105 active:scale-95 flex items-center"
            >
              {t('home.hero_view_docs')}
              <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
            </Link>
          </div>
        </div>

        <div className="md:w-1/2 flex justify-center items-center h-[500px] md:h-[600px] w-full md:w-auto slide-in-right">
          <img src={logo} alt="Damelio Logo" className="h-[90%] w-auto object-contain animate-pulse drop-shadow-lg" />
        </div>
      </div>
    </div>
  );
}